import React from 'react';
import { FormData, FormErrors } from '../../types';
import { FormField, Select, TextArea } from '../FormField';
interface SectionProps {
  data: FormData;
  errors: FormErrors;
  onChange: (field: keyof FormData, value: any) => void;
}
export function Section8({
  data,
  errors,
  onChange
}: SectionProps) {
  return <div className="space-y-6" data-id="element-158">
      <div className="mb-8 border-b border-plateado/30 pb-4" data-id="element-159">
        <h2 className="font-serif text-2xl text-azul-profundo" data-id="element-160">
          <span className="text-dorado mr-2" data-id="element-161">Sección 08 ·</span>
          Retos y Acompañamiento
        </h2>
        <p className="text-gray-600 mt-2" data-id="element-162">
          Entender tus obstáculos nos ayuda a diseñar el soporte adecuado.
        </p>
      </div>

      <FormField label="¿Cuáles han sido tus principales obstáculos en intentos anteriores por mejorar tu salud?" name="obstaculos" error={errors.obstaculos} required data-id="element-163">
        <TextArea id="obstaculos" value={data.obstaculos} onChange={e => onChange('obstaculos', e.target.value)} error={!!errors.obstaculos} placeholder="Ej. Falta de tiempo, dietas muy restrictivas, falta de apoyo, aburrimiento..." className="min-h-[100px]" data-id="element-164" />
      </FormField>

      <FormField label="¿Qué nivel de acompañamiento sientes que necesitas en este momento?" name="acompanamiento" error={errors.acompanamiento} required data-id="element-165">
        <div className="space-y-4 mt-2" data-id="element-166">
          {[{
          value: 'basico',
          label: 'Básico',
          desc: 'Solo necesito el plan y la estructura, yo me encargo de ejecutarlo por mi cuenta.'
        }, {
          value: 'intermedio',
          label: 'Intermedio',
          desc: 'Necesito el plan y revisiones quincenales para mantener el rumbo.'
        }, {
          value: 'intensivo',
          label: 'Intensivo',
          desc: 'Necesito seguimiento cercano, apoyo constante y ajustes semanales para no rendirme.'
        }].map(option => <label key={option.value} className="flex items-start space-x-3 p-4 border-2 border-plateado rounded-xl cursor-pointer hover:border-dorado transition-colors bg-white" data-id="element-167">
              <input type="radio" name="acompanamiento" value={option.value} checked={data.acompanamiento === option.value} onChange={e => onChange('acompanamiento', e.target.value)} className="w-5 h-5 mt-0.5 text-dorado focus:ring-dorado flex-shrink-0" data-id="element-168" />
              <div data-id="element-169">
                <span className="block font-medium text-azul-profundo" data-id="element-170">
                  {option.label}
                </span>
                <span className="block text-sm text-gray-600 mt-1" data-id="element-171">
                  {option.desc}
                </span>
              </div>
            </label>)}
        </div>
      </FormField>

      <FormField label="¿Qué disponibilidad de tiempo semanal tienes para dedicarle al programa?" name="disponibilidad" error={errors.disponibilidad} required data-id="element-172">
        <Select id="disponibilidad" value={data.disponibilidad} onChange={e => onChange('disponibilidad', e.target.value)} error={!!errors.disponibilidad} data-id="element-173">
          <option value="" data-id="element-174">Selecciona...</option>
          <option value="2-3h" data-id="element-175">
            2 a 3 horas semanales (lo mínimo indispensable)
          </option>
          <option value="4-6h" data-id="element-176">
            4 a 6 horas semanales (ideal para crear hábitos)
          </option>
          <option value="7+h" data-id="element-177">
            7 o más horas semanales (compromiso total)
          </option>
        </Select>
      </FormField>
    </div>;
}